(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/team-members/inactive-member.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/team-members/inactive-member.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _svs$arena$pages$team = svs.arena.pages.teams.components,
  MemberPopover = _svs$arena$pages$team.MemberPopover,
  MemberPopoverItem = _svs$arena$pages$team.MemberPopoverItem;
const _svs$arena$pages$team2 = svs.arena.pages.teams.teamMembers,
  MemberSendEmail = _svs$arena$pages$team2.MemberSendEmail,
  MemberName = _svs$arena$pages$team2.MemberName;
const putActivateMemberAsync = svs.arena.service.teamsService.putActivateMemberAsync;
const changeMemberActivity = svs.arena.store.teams.actions.changeMemberActivity;
const useRemoveMember = svs.arena.shared.hooks.useRemoveMember;
const _svs$arena$pages$team3 = svs.arena.pages.teams.dialogs,
  showActivateMemberSuccess = _svs$arena$pages$team3.showActivateMemberSuccess,
  showTechnicalError = _svs$arena$pages$team3.showTechnicalError;
const InactiveMember = _ref => {
  let _ref$member = _ref.member,
    customerId = _ref$member.customerId,
    firstName = _ref$member.firstName,
    lastName = _ref$member.lastName,
    isLeader = _ref.isLeader,
    teamId = _ref.teamId,
    teamName = _ref.teamName;
  const dispatch = ReactRedux.useDispatch();
  const _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isShowEmail = _React$useState2[0],
    setIsShowEmail = _React$useState2[1];
  const isInactive = true;
  const _useRemoveMember = useRemoveMember(teamId, teamName, customerId, firstName, lastName, false, isInactive),
    onRemoveMember = _useRemoveMember.onRemoveMember;
  const onShowEmail = () => {
    const track = {
      category: 'spela-tillsammans',
      action: 'action_members_inactive',
      opt_label: 'show_email_field'
    };
    svs.components.analytics.trackEvent(track);
    setIsShowEmail(true);
  };
  const activate = async () => {
    const _await$putActivateMem = await putActivateMemberAsync(customerId, teamId),
      error = _await$putActivateMem.error;
    if (error) {
      if (error.code === '22 108') {
        dispatch(changeMemberActivity({
          teamId,
          customerId,
          active: true
        }));
        return;
      }
      showTechnicalError();
    } else {
      const track = {
        category: 'spela-tillsammans',
        action: 'action_members_inactive',
        opt_label: 'activate'
      };
      svs.components.analytics.trackEvent(track);
      dispatch(changeMemberActivity({
        teamId,
        customerId,
        active: true
      }));
      showActivateMemberSuccess(firstName, lastName);
    }
  };
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "u-flex margin-v-1"
  }, React.createElement("div", {
    className: "u-flex-grow-1"
  }, React.createElement("div", {
    className: "padding-left-1 f-400 data-hj-suppress"
  }, React.createElement(MemberName, {
    className: "padding-left-1",
    firstName: firstName,
    lastName: lastName
  }))), React.createElement("div", {
    className: "align-right"
  }, isLeader && React.createElement("div", {
    className: "padding-right-1"
  }, React.createElement(MemberPopover, null, React.createElement(MemberPopoverItem, {
    onClick: onShowEmail
  }, " Skicka e-post "), React.createElement(MemberPopoverItem, {
    onClick: activate
  }, " Aktivera "), React.createElement(MemberPopoverItem, {
    onClick: onRemoveMember
  }, " Ta bort "))))), isShowEmail && React.createElement(MemberSendEmail, {
    customerId: customerId,
    firstName: firstName,
    isInactive: true,
    lastName: lastName,
    onHide: () => setIsShowEmail(false),
    teamId: teamId
  }));
};
svs.arena.pages.teams.teamMembers.InactiveMember = InactiveMember;

 })(window);